import React, { lazy, Suspense, useEffect, useRef } from 'react'
import { useTranslation } from '../i18n/LanguageContext'
import { SectionBoundary } from './DeferredSection'

const CarMap = lazy(() => import('./CarMap'))

function MapStatus({ failed = false, onClose }) {
  const { t } = useTranslation()
  const closeButton = useRef(null)
  useEffect(() => { closeButton.current?.focus() }, [])
  return <section className={`section-status map-module-status ${failed ? 'map-module-error' : 'map-module-loading'}`} role={failed ? 'alert' : 'status'}>
    <h2>{t(failed ? 'The map could not be loaded' : 'Loading map...')}</h2>
    <p>{t(failed
      ? 'Your list and unsaved plan are still here. Continue with the list; save important inputs before reloading to try the map again.'
      : 'You can continue with the list while the map loads.')}</p>
    <button type="button" ref={closeButton} onClick={onClose}>{t('Continue with list')}</button>
  </section>
}

// Only the optional map can unmount on error. The cards (and their unsaved
// purchase plans) are siblings, never children of this boundary or Suspense.
// A rejected lazy import stays rejected until a page reload; do not promise an
// automatic retry or reload a page that may contain the buyer's unsaved inputs.
export default function DeferredMap({ onClose, ...props }) {
  return <SectionBoundary fallback={<MapStatus failed onClose={onClose} />}>
    <Suspense fallback={<MapStatus onClose={onClose} />}>
      <CarMap {...props} onClose={onClose} />
    </Suspense>
  </SectionBoundary>
}
